import * as history from 'history'
import rootReducer from './store/ducks'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

export const browserHistory = history.createBrowserHistory()
export default function configStore () {
  return createStore(rootReducer(browserHistory), applyMiddleware(thunk))
}
